"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _CardTitle = _interopRequireDefault(require("./CardTitle"));
var _CustomMenuList = _interopRequireDefault(require("../misc/CustomMenuList"));
var _tooltip = require("../tooltip");
var _ActionCard = _interopRequireDefault(require("./ActionCard.style"));
var _excluded = ["title", "subtitle", "titleProps", "delimiterProps", "customTitle", "renderMedia", "contextualMenu", "children", "className", "isTile", "connectWithTooltip", "tooltipProps"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ActionCard = function ActionCard(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    titleProps = _ref.titleProps,
    delimiterProps = _ref.delimiterProps,
    customTitle = _ref.customTitle,
    renderMedia = _ref.renderMedia,
    contextualMenu = _ref.contextualMenu,
    children = _ref.children,
    className = _ref.className,
    isTile = _ref.isTile,
    connectWithTooltip = _ref.connectWithTooltip,
    tooltipProps = _ref.tooltipProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var actionCardTooltipProps = {
    dataTip: title || tooltipProps.dataTip,
    dataFor: "action-card-title-".concat(titleProps.id) || tooltipProps.dataFor,
    dataPlace: 'top' || tooltipProps.dataPlace,
    dataOffset: '' || tooltipProps.dataOffset
  };
  return /*#__PURE__*/_react["default"].createElement(_ActionCard["default"], {
    className: "action-card-wrapper ".concat(className),
    isTile: isTile
  }, renderMedia, /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: "action-card-container"
  }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: "action-card-header"
  }, contextualMenu && /*#__PURE__*/_react["default"].createElement(_CustomMenuList["default"], {
    menuConfig: contextualMenu,
    className: "contextual-menu"
  }), title && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, connectWithTooltip && /*#__PURE__*/_react["default"].createElement(_tooltip.Tooltip, {
    id: actionCardTooltipProps.dataFor
  }), /*#__PURE__*/_react["default"].createElement(_CardTitle["default"], _extends({
    className: "action-card-title",
    title: title,
    titleProps: titleProps,
    delimiterProps: delimiterProps,
    withSubtitle: !(0, _utils.isBlank)(subtitle)
  }, connectWithTooltip && {
    tooltipProps: _objectSpread({}, {
      'data-tip': actionCardTooltipProps.dataTip,
      'data-for': actionCardTooltipProps.dataFor,
      'data-place': actionCardTooltipProps.dataPlace,
      'data-offset': actionCardTooltipProps.dataOffset
    } || tooltipProps)
  }))), customTitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "action-card-custom-title"
  }, customTitle)), subtitle && /*#__PURE__*/_react["default"].createElement("div", {
    className: "action-card-subtitle"
  }, subtitle), children));
};
ActionCard.defaultProps = {
  className: '',
  title: '',
  subtitle: '',
  isTile: false,
  connectWithTooltip: false,
  titleProps: {
    id: '',
    titleFontSize: '',
    isBold: true,
    isUppercase: false,
    textTransform: 'capitalize'
  },
  delimiterProps: {
    titleDelimiter: false,
    position: 'left',
    topMargin: '',
    type: 'small'
  },
  contextualMenu: '',
  customTitle: '',
  renderMedia: null,
  children: undefined,
  tooltipProps: {
    dataTip: '',
    dataFor: '',
    dataPlace: 'top',
    dataOffset: ''
  }
};
ActionCard.propTypes = {
  renderMedia: _propTypes["default"].node,
  className: _propTypes["default"].string,
  /** Text or html to be displayed inside the card */
  children: _propTypes["default"].node,
  /** A text to be displayed as the card title */
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** A text to be displayed as the card subtitle */
  subtitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /** Attributes for the card title */
  titleProps: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    titleFontSize: _propTypes["default"].string,
    isBold: _propTypes["default"].bool,
    isUppercase: _propTypes["default"].bool,
    textTransform: _propTypes["default"].oneOf(['none', 'capitalize', 'uppercase', 'lowercase'])
  }),
  /** Attributes for the delimiter */
  delimiterProps: _propTypes["default"].shape({
    titleDelimiter: _propTypes["default"].bool,
    position: _propTypes["default"].string,
    topMargin: _propTypes["default"].string,
    type: _propTypes["default"].oneOf(['small', 'medium'])
  }),
  contextualMenu: _propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].arrayOf(_propTypes["default"].shape({})), _propTypes["default"].node]),
  customTitle: _propTypes["default"].node,
  isTile: _propTypes["default"].bool,
  connectWithTooltip: _propTypes["default"].bool,
  tooltipProps: _propTypes["default"].shape({
    dataTip: _propTypes["default"].string,
    dataFor: _propTypes["default"].string,
    dataPlace: _propTypes["default"].string,
    dataOffset: _propTypes["default"].string
  })
};
var _default = exports["default"] = ActionCard;